// extracted by mini-css-extract-plugin
export default {"operatorCtaPlaceholder":"operator-cta-module__operatorCtaPlaceholder__1nXa5","operatorCtaClosed":"operator-cta-module__operatorCtaClosed__YDyKI"};